import React from 'react'
import { ShareButton } from '../../../Buttons/ShareButton'

type ShProps = {
  questionLink: string
  label?: string
  size?: 'sm' | 'lg'
}

export const Share: React.FC<React.PropsWithChildren<ShProps>> = ({
  questionLink,
  label,
  size = 'sm'
}) => {
  return (
    <ShareButton shareLink={questionLink} size={size} border={false} label={label} />
  )
}
